module.exports = __webpack_public_path__ + "img/point-collecte-icon.c637a3e3.svg";